"use client"

import { motion } from "framer-motion"
import { FaIdCard, FaBuilding, FaInfoCircle, FaTimes } from "react-icons/fa"

const inputVariants = {
  focus: { scale: 1.02, transition: { duration: 0.2 } },
}

const backdropVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
}

const modalVariants = {
  hidden: { opacity: 0, scale: 0.8, y: 50 },
  visible: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: {
      type: "spring",
      stiffness: 300,
      damping: 25,
    },
  },
  exit: {
    opacity: 0,
    scale: 0.8,
    y: 50,
    transition: {
      duration: 0.2,
    },
  },
}

const AdditionalInfoModal = ({ formData, handleChange, handleSubmit, closeModal }) => {
  return (
    <motion.div
      className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4"
      variants={backdropVariants}
      initial="hidden"
      animate="visible"
      exit="hidden"
      onClick={closeModal}
    >
      <motion.div
        className="bg-white rounded-xl shadow-2xl overflow-hidden w-full max-w-2xl"
        variants={modalVariants}
        initial="hidden"
        animate="visible"
        exit="exit"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="bg-gradient-to-r from-[var(--navy-blue)] to-[var(--navy-blue-light)] py-4 px-6 flex justify-between items-center">
          <div>
            <h3 className="text-white text-xl font-semibold">Información Adicional</h3>
            <p className="text-blue-100 text-sm">Paso 2 de 2</p>
          </div>
          <button onClick={closeModal} className="text-white hover:text-gray-200 transition-colors">
            <FaTimes size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <motion.div variants={inputVariants} whileFocus="focus">
              <label htmlFor="NSS" className="block mb-1 text-sm font-medium text-gray-700">
                Número de Seguridad Social
              </label>
              <div className="relative">
                <FaIdCard className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                <input
                  type="text"
                  id="NSS"
                  name="NSS"
                  value={formData.NSS}
                  onChange={handleChange}
                  className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--gold)]"
                  required
                  placeholder="NSS"
                />
              </div>
            </motion.div>

            <motion.div variants={inputVariants} whileFocus="focus">
              <label htmlFor="RFC" className="block mb-1 text-sm font-medium text-gray-700">
                RFC
              </label>
              <div className="relative">
                <FaIdCard className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                <input
                  type="text"
                  id="RFC"
                  name="RFC"
                  value={formData.RFC}
                  onChange={handleChange}
                  className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--gold)]"
                  required
                  placeholder="RFC"
                />
              </div>
            </motion.div>
          </div>

          <motion.div variants={inputVariants} whileFocus="focus">
            <label htmlFor="position" className="block mb-1 text-sm font-medium text-gray-700">
              Posición / Ocupación
            </label>
            <div className="relative">
              <FaBuilding className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
              <input
                type="text"
                id="position"
                name="position"
                value={formData.position}
                onChange={handleChange}
                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--gold)]"
                required
                placeholder="Ocupación actual"
              />
            </div>
          </motion.div>

          <motion.div variants={inputVariants} whileFocus="focus">
            <label htmlFor="about_me" className="block mb-1 text-sm font-medium text-gray-700">
              Sobre mí
            </label>
            <div className="relative">
              <FaInfoCircle className="absolute left-3 top-3 text-gray-400" />
              <textarea
                id="about_me"
                name="about_me"
                value={formData.about_me}
                onChange={handleChange}
                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[var(--gold)]"
                rows={3}
                placeholder="Breve descripción sobre usted"
              ></textarea>
            </div>
          </motion.div>

          <div className="flex gap-4 pt-4">
            <motion.button
              type="button"
              onClick={closeModal}
              className="w-1/2 bg-gray-200 text-gray-800 py-3 px-4 rounded-lg hover:bg-gray-300 transition duration-300 font-medium"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              Volver
            </motion.button>
            <motion.button
              type="submit"
              className="w-1/2 bg-gradient-to-r from-[var(--gold)] to-[var(--gold-dark)] text-white py-3 px-4 rounded-lg hover:from-[var(--gold-dark)] hover:to-[var(--gold)] transition duration-300 font-medium"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              Registrar Cuenta
            </motion.button>
          </div>
        </form>
      </motion.div>
    </motion.div>
  )
}

export default AdditionalInfoModal

